import React, { useEffect, useState } from 'react';
import api from '../api';
import BackButton from '../components/BackButton';

export default function QRCodePage() {
  const [qr, setQr] = useState(null);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState('');

  useEffect(() => { fetchQR(); }, []);

  const fetchQR = async () => {
    try {
      const res = await api.get('/qrcode/current');
      setQr(res.data.qr);
    } catch (err) {
      console.error('Failed to load QR', err);
    }
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(selected);
    }
  };

  const handleUpload = async () => {
    if (!file) return alert('Please select a file');

    const formData = new FormData();
    formData.append('qr', file);

    try {
      await api.post('/qrcode/upload', formData);
      alert('✅ QR code uploaded');
      setFile(null);
      setPreview('');
      fetchQR();
    } catch {
      alert('❌ Upload failed');
    }
  };

  const handleDelete = async () => {
    if (!qr) return;
    try {
      await api.delete(`/qrcode/${qr.QRID}`);
      alert('🗑️ QR code deleted');
      setQr(null);
    } catch {
      alert('❌ Delete failed');
    }
  };

  return (
    <div className="container mt-4">
      <BackButton />
      <h4 className="mb-4 text-primary">Manage QR Code</h4>

      <div className="row g-4">
        <div className="col-md-6">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h5 className="card-title">Upload New QR Code</h5>
              <input type="file" className="form-control mb-2" accept="image/*" onChange={handleFileChange} />
              {preview && <img src={preview} alt="Preview" className="img-fluid rounded border mb-2" style={{ maxHeight: '180px' }} />}
              <button className="btn btn-primary w-100" onClick={handleUpload} disabled={!file}>Upload QR Code</button>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-sm border-0 text-center">
            <div className="card-body">
              <h5 className="card-title">Current QR Code</h5>
              {qr ? (
                <>
                  <img src={`http://localhost:8000/uploads/qrcodes/${qr.FileName}`} alt="QR Code" className="img-fluid rounded border mb-2" style={{ maxHeight: '180px' }} />
                  <p><button className="btn btn-outline-danger btn-sm" onClick={handleDelete}>Delete QR Code</button></p>
                </>
              ) : (
                <p className="text-muted">No QR code uploaded yet.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
